import { UI_LANGUAGE_TAGS } from '../../../constants/constants';
import { ITransaction } from '../../../interface/transaction';
import { ITransactionTypes } from '../../../interface/transactionTypes';

export const getTransactionTypeName = (
  translations: ITransactionTypes['translations'] | undefined,
  appLanguage: string,
) =>
  translations?.find((translation) => translation.language.startsWith(appLanguage))
    ?.nameTranslation ??
  translations?.find((translation) => translation)?.nameTranslation ??
  '-';

export const getTransactionTypeSubject = (
  translations: ITransactionTypes['translations'] | undefined,
  matterLanguage: string | undefined,
  appLanguage: string,
) =>
  translations?.find((translation) => translation.language === matterLanguage)
    ?.subjectTranslation ||
  translations?.find((translation) => translation.language === matterLanguage)?.nameTranslation ||
  translations?.find((translation) => translation.language === appLanguage)?.subjectTranslation ||
  translations?.find((translation) => translation.language === appLanguage)?.nameTranslation ||
  translations?.find((translation) => translation.language === UI_LANGUAGE_TAGS['en'])
    ?.nameTranslation ||
  '-';

export const buildTransactionTypeSelection = (
  transaction: ITransaction | null,
  type: ITransactionTypes,
  subject: string | undefined,
) =>
  ({
    ...transaction,
    transactionType: type,
    transactionTypeId: type?.id,
    unitId: type?.unitId,
    unit: type?.unit,
    isManualUnitPrice: false,
    shouldLoadServerPrice: true,
    ...(!transaction?.isSubjectSetByUser &&
      !transaction?.isFromMailOrAppointment &&
      !transaction?.timerId && {
        currentSubject: subject ?? '',
      }),
  }) as ITransaction;
